module.exports = "/dist/assets/icon-analytics-coming-soon.svg";